export const INDUSTRIES = [
    {
        slug: "commercial-fleets",
        title: "Commercial Fleets",
        short: "Charging while vehicles are parked overnight or between shifts.",
        problem: "Manual plug-in cycles and cable handling take time out of every shift.",
        advantage:
            "Vans, taxis and service vehicles simply park — charging starts automatically. Reduced labour, no cable handling, fleet always ready.",
        useCases: ["Delivery vans", "Taxi fleets", "Service vehicles", "Depot overnight charging"],
        image: "https://images.unsplash.com/photo-1775047734765-df970880aca8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxlbGVjdHJpYyUyMHZlaGljbGUlMjBmbGVldHxlbnwwfHx8fDE3Nzg1ODk0NDN8MA&ixlib=rb-4.1.0&q=85",
    },
    {
        slug: "corporate-parking",
        title: "Corporate & Employee Parking",
        short: "Employees park. Vehicles charge automatically throughout the workday.",
        problem: "Corporate parking full of cables, plugs and shared charging bottlenecks.",
        advantage:
            "Employees don't manage charging. Cars top up during the day whenever parked over a pad — zero friction for HR, facilities or the driver.",
        useCases: ["Corporate campuses", "Office parks", "Reserved bays", "Executive parking"],
        image: "https://images.unsplash.com/photo-1774031528911-608cd7a0cc70?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGNpdHklMjBpbmZyYXN0cnVjdHVyZXxlbnwwfHx8fDE3Nzg1ODk0ODl8MA&ixlib=rb-4.1.0&q=85",
    },
    {
        slug: "hospitality-residential",
        title: "Hotels & Residential Developments",
        short: "Premium charging without visible cables or infrastructure clutter.",
        problem: "Cables and chargers hurt architectural design and require constant maintenance.",
        advantage:
            "Charging integrated into the parking surface. Guests and residents experience seamless, invisible charging — cleaner spaces, lower service overhead.",
        useCases: ["Hotels", "Resorts", "Residential garages", "Premium developments"],
        image: "https://images.pexels.com/photos/19841115/pexels-photo-19841115.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        slug: "warehousing-logistics",
        title: "Warehouses & Logistics",
        short: "Opportunity charging for AGVs, forklifts and mobile equipment.",
        problem: "Charging bottlenecks and manual plug-in slow down automated operations.",
        advantage:
            "AGVs, autonomous robots, forklifts and mobile equipment top up wirelessly between tasks — no operator, no downtime, continuous throughput.",
        useCases: ["AGVs", "Autonomous mobile robots", "Electric forklifts", "Mobile equipment"],
        image: "https://images.unsplash.com/photo-1761195696590-3490ea770aa1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjByb2JvdHxlbnwwfHx8fDE3Nzg1ODk0ODl8MA&ixlib=rb-4.1.0&q=85",
    },
    {
        slug: "two-wheelers",
        title: "Motorbikes, Scooters & E-Rollers",
        short: "Wireless charging for electric motorbikes, scooters and shared e-rollers.",
        problem: "Riders leaving cables dangling, damaged ports, and shared-fleet vehicles constantly out of service for charging.",
        advantage:
            "Riders simply park over the pad — no cable, no port, no vandalism target. Ideal for shared micromobility, urban delivery riders and residential e-bike / e-scooter garages.",
        useCases: ["Electric motorbikes", "E-scooters & e-mopeds", "Shared micromobility fleets", "Delivery riders"],
        image: "https://images.unsplash.com/photo-1566936737687-8f392a237b8b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    },
    {
        slug: "airports-ground-ops",
        title: "Airports & Ground Operations",
        short: "Wireless charging for ground support equipment and service vehicles.",
        problem: "Loose cables on active aprons are a foreign object debris (FOD) hazard.",
        advantage:
            "Ground support and service vehicles charge without cables — safer apron, faster turnaround, ready for autonomous airport operations.",
        useCases: ["Ground support equipment", "Airport service vehicles", "Autonomous airport systems", "Baggage tugs"],
        image: "https://images.unsplash.com/photo-1694729101068-a2c621f877b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxhdXRvbm9tb3VzJTIwdmVoaWNsZXxlbnwwfHx8fDE3Nzg1ODk0ODl8MA&ixlib=rb-4.1.0&q=85",
    },
];
